import { downgradeInjectable } from "@angular/upgrade/static";
import { GroupService as GroupService2 } from "@app/services/groups/group.service";
import { ResellerAccountMappingService } from "@app/services/resellerAccountMapping.service";
import { ResellerUserGroupMappingService } from "@app/services/resellerUserGroupMapping.service";
import { AccelerometerRecordService } from "@services/accelerometerRecord.service";
import { AxleWeightService } from "@services/axleWeight.service";
import { CameraCommunicationServer } from "@services/cameraCommunicationServer.service";
import { DateService } from "@services/date.service";
import { PopupService } from "@services/popup.service";
import { PowerLossHistoryService } from "@services/powerLossHistory.service";
import { RouteConfigHelperProvider } from "@services/routeConfigHelper.provider";
import { ThemeService } from "@services/theme.service";
import { ThemeServiceNew } from "./theming/theme.service";
import { TranslationService } from "@services/translation.service";
import { UtilisationService } from "@services/utilisation.service";
import { ValidationService } from "@services/validation.service";
import * as angular from "angular";
import { CameraDisplayService } from "../main/components/videos/cameraDisplay.service";
import { TemperatureService } from "../main/modules/temperature/_services/temperature.service";
import { AccountSettingsService } from "./account-settings.service";
import { AccountService } from "./account.service";
import { AccountFeatureService } from "./accountFeature.service";
import { AccountUserMappingService } from "./accountUserMapping.service.ajs";
import { AudioService } from "./audio.service";
import { AuthorizationService } from "./authorization.service";
import { AvatarService } from "./avatar.service";
import { BreadcrumbService } from "./breadcrumb.service";
import { CacheService } from "./cache.Service";
import { DataCacheService } from "./caching/data-cache.service";
import { CanvasService } from "./canvas.service";
import { ChartService } from "./charts.service";
import { ColourService } from "./colour.service";
import { ConstantsService } from "./constantsService";
import { ContextualSpeedingOverrideService } from "./contextual-speeding-override.service";
import { CurrentUserService } from "./currentUser.service";
import { Debounce } from "./debounce.service";
import { DelayService } from "./delay.service";
import { DeviceProfileService } from "./device-profile.service";
import { DisplayService } from "./display.service";
import { DriverService } from "./driver.service";
import { DriverAssignmentService } from "./driverAssignment.service";
import { EnumService as EnumValuesService } from "./enum.service";
import { EventService } from "./event.services";
import { FileReaderService } from "./fileReader.service";
import { FilterOptionsService } from "./filterOptions.service";
import { FullScreenService } from "./fullscreen.service";
import { GanttSeriesService } from "./ganttSeries.service";
import { GeocodeService } from "./geocode.service";
import { GeofenceService } from "./geofence.service";
import { GoogleService } from "./google.service";
import { GoogleMarkerService } from "./googleMarker.service";
import { GroupService } from "./group.service.ajs";
import { HTMLService } from "./htmlService.service";
import { InputTypeService } from "./inputType.service";
import { JourneyService } from "./journey.service";
import { LocationInformationService } from "./location-information/location-information.service";
import { LoginService } from "./login.service.ajs";
import { LoginHistoryService } from "./loginHistory.service.ajs";
import { MapService } from "./map.service";
import { MapzenService } from "./mapzen.service";
import { MessageDialogService } from "./messageDialog.service";
import { NavigationService } from "./navigation.service";
import { NotifyFactory } from "./notify.factory";
import { ObservationsService } from "./observations.service";
import { PlotService } from "./plot.service";
import { PlotEventService } from "./plotEvent.service";
import { PreferencesService } from "./preferences.service";
import { PrintService } from "./print.service";
import { ProductService } from "./product.service";
import { ReasonCodeService } from "./reasonCode.service";
import { FilterBarService } from "./resourceFilterBar.service";
import { ResponsiveService } from "./responsive.service";
import { SamlService } from "./saml.service";
import { SessionService } from "./session.service";
import { TachoService } from "./tacho.service";
import { TagsService } from "./tags.service";
import { ThrottleService } from "./throttle.service";
import { UnitConversionService } from "./unitConversion.service";
import { UserMappingsService } from "./userMappings.service";
import { UserResellerMappingService } from "./userResellerMappingService.ajs";
import { UsersService } from "./users.service";
import { VehicleService } from "./vehicle.service";
import { VehicleInputService } from "./vehicleInput.service";
import { VeriDate } from "./veriDate.service";
import { VeriMarkerService } from "./veriMarker.service";
import { VersionService } from "./version.service";
import { VorService } from "./vor.service";
import { WebSocketService } from "./websocket.service";

angular
    .module("app.components.util.api", ["ui.router", "angular-cache"])
    .service("accountSettingsService", downgradeInjectable(AccountSettingsService))
    .service("samlService", downgradeInjectable(SamlService))
    .service("responsiveService", downgradeInjectable(ResponsiveService))
    .service("dataCacheService", downgradeInjectable(DataCacheService))
    .service("locationInformationService", downgradeInjectable(LocationInformationService))
    .service("groupService2", downgradeInjectable(GroupService2))
    .service("cacheService", CacheService)
    .service("sessionService", SessionService)
    .service("authorizationService", AuthorizationService)
    .service("navigationService", NavigationService)
    .service("veriDate", VeriDate)
    .service("colourService", ColourService)
    .service("themeService", ThemeService)
    .service("themeServiceNew", ThemeServiceNew)
    .service("accountService", AccountService)
    .service("breadcrumbService", BreadcrumbService)
    .service("currentUserService", CurrentUserService)
    .service("accountUserMappingService", AccountUserMappingService)
    .service("debounceService", Debounce)
    .service("htmlService", HTMLService)
    .service("delayService", DelayService)
    .service("cameraDisplayService", CameraDisplayService)
    .service("displayService", DisplayService)
    .service("popupService", PopupService)
    .service("fileReaderService", FileReaderService)
    .service("fullScreenService", FullScreenService)
    .service("geocodeService", GeocodeService)
    .service("geofenceService", GeofenceService)
    .service("tagsService", TagsService)
    .service("temperatureService", TemperatureService)
    .service("chartService", ChartService)
    .service("driverService", DriverService)
    .service("driverAssignmentService", DriverAssignmentService)
    .service("enumValuesService", EnumValuesService)
    .service("googleService", GoogleService)
    .service("filterOptionsService", FilterOptionsService)
    .service("groupService", GroupService)
    .service("loginService", LoginService)
    .service("versionService", VersionService)
    .service("webSocketService", WebSocketService)
    .service("mapService", MapService)
    .service("mapzenService", MapzenService)
    .service("unitConversionService", UnitConversionService)
    .service("tachoService", TachoService)
    .service("usersService", UsersService)
    .service("accountFeatureService", AccountFeatureService)
    .service("avatarService", AvatarService)
    .service("canvasService", CanvasService)
    .service("throttleService", ThrottleService)
    .service("filterBarService", FilterBarService)
    .service("printService", PrintService)
    .service("vehicleService", VehicleService)
    .service("eventService", EventService)
    .service("accelerometerRecordService", AccelerometerRecordService)
    .service("journeyService", JourneyService)
    .service("plotService", PlotService)
    .service("preferencesService", PreferencesService)
    .service("plotEventService", PlotEventService)
    .service("reasonCodeService", ReasonCodeService)
    .service("vehicleInputService", VehicleInputService)
    .service("veriMarkerService", VeriMarkerService)
    .service("googleMarkerService", GoogleMarkerService)
    .service("observationsService", ObservationsService)
    .service("audioService", AudioService)
    .service("ganttSeriesService", GanttSeriesService)
    .service("loginHistoryService", LoginHistoryService)
    .service("constantsService", ConstantsService)
    .service("translationService", TranslationService)
    .service("utilisationService", UtilisationService)
    .service("cameraCommunicationServer", CameraCommunicationServer)
    .service("validationService", ValidationService)
    .service("messageDialogService", MessageDialogService)
    .service("inputTypeService", InputTypeService)
    .service("userMappingsService", UserMappingsService)
    .service("productService", ProductService)
    .service("vorService", VorService)
    .service("axleWeightService", AxleWeightService)
    .service("powerLossHistoryService", PowerLossHistoryService)
    .service("dateService", downgradeInjectable(DateService))
    .service("contextualSpeedingOverrideService", downgradeInjectable(ContextualSpeedingOverrideService))
    .service("deviceProfileService", DeviceProfileService)
    .service("userResellerMappingService", UserResellerMappingService)
    .service("resellerAccountMappingService", ResellerAccountMappingService)
    .service("resellerUserGroupMappingService", ResellerUserGroupMappingService)

    .factory("veriNotifyFactory", NotifyFactory)

    //.provider("runtimeStates", RuntimeStatesProvider)
    .provider("routeConfigHelper", RouteConfigHelperProvider);
